const SIEMENS_GREEN = "#4DD384";
const BG = "#FAFAFA";
const TEXT = "#000000";
const BUTTONS = "#E0F1F4";

/** the standard Siemens green color */
export const PRIMARY_COLOR = SIEMENS_GREEN;
export const TEXT_COLOR = TEXT;
export const BG_COLOR = BG;
export const ACTION_COLOR = BUTTONS;